/**
 * Marca do Grupo Nicnet.
 *
 * Transcrita de `public/media/logos/logo-grupo-nicnet.svg` do monolito. Cópia
 * deliberada, não dependência — pelo mesmo motivo dos tokens Maia: o build desta página
 * não pode precisar do Nicon para funcionar. Ao atualizar a marca lá, replicar aqui.
 *
 * Uma alteração em relação ao original: o texto vinha em `#FEFEFE`, porque aquele
 * arquivo é usado sobre fundo escuro (o selo do rodapé do site). Aqui ele é
 * `currentColor`, senão a marca sumiria no tema claro. O mosaico mantém as cores da
 * marca, que funcionam nos dois temas.
 */
export const LogoGrupoNicnet = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 308 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Grupo Nicnet"
    className={className}
  >
    <title>Grupo Nicnet</title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.744 46.4413H68.614V69.4724H45.744V46.4413Z"
      fill="#166AC4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.744 23.4102H68.614V46.4413H45.744V23.4102Z"
      fill="#0395FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.744 0.375H68.614V23.41H45.744V0.375Z"
      fill="#0DCBC9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8701 46.4413H45.744V69.4724H22.8701V46.4413Z"
      fill="#0395FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 46.4413H22.8701V69.4724H0V46.4413Z"
      fill="#0DCBC9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8701 23.4102H45.744V46.4413H22.8701V23.4102Z"
      fill="#0DCBC9"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M255.308 57.9509C255.479 57.775 255.525 57.5288 255.436 57.306C255.343 57.0832 255.133 56.9386 254.889 56.9425L245.912 56.9816C245.753 56.9816 245.61 56.923 245.497 56.8097C245.384 56.6963 245.326 56.5556 245.326 56.3915V51.0802C245.326 50.7558 245.59 50.4901 245.916 50.4901H258.746C260.365 50.4901 261.692 49.1535 261.692 47.5237V42.4079C261.692 42.0796 261.424 41.8099 261.098 41.8099H245.916C245.59 41.8099 245.326 41.5442 245.326 41.2159V36.057C245.326 35.7326 245.59 35.463 245.916 35.463H261.459C263.873 35.5099 265.736 34.3921 265.736 31.7853V24.2698C265.736 23.9415 265.468 23.6719 265.142 23.6719H233.245C232.919 23.6719 232.651 23.9415 232.651 24.2698V62.9964C232.578 68.9642 236.684 68.7219 239.656 68.7219H243.642C244.29 68.7219 244.849 68.4913 245.303 68.0301L255.312 57.9509H255.308Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M263.198 56.9348H259.596C259.111 56.9348 258.684 57.1107 258.343 57.4546L248.163 67.7098C247.996 67.8817 247.946 68.1319 248.035 68.3546C248.128 68.5813 248.334 68.722 248.578 68.722C252.494 68.722 258.762 68.722 262.678 68.722C263.485 68.722 264.094 68.5735 264.68 67.9873C265.262 67.4049 265.55 66.7093 265.55 65.8807V59.2993C265.55 57.9939 264.494 56.9309 263.198 56.9309V56.9348Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M283.188 68.7336H293.705C294.031 68.7336 294.299 68.464 294.299 68.1357V36.057C294.299 35.7326 294.563 35.463 294.885 35.463H306.501C306.664 35.463 306.803 35.4043 306.924 35.2871C307.04 35.1699 307.094 35.0292 307.094 34.8611L307.056 27.5684C306.912 25.3055 305.1 23.75 302.888 23.6719H270.397C270.071 23.6719 269.803 23.9415 269.803 24.2698V32.2152C269.803 34.2358 271.235 35.463 273.191 35.463H282.001C282.323 35.463 282.59 35.7287 282.59 36.057V68.1357C282.59 68.464 282.858 68.7336 283.184 68.7336H283.188Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114.055 68.7219L124.192 68.7258C124.355 68.7258 124.499 68.6672 124.615 68.5499C124.732 68.4327 124.79 68.292 124.79 68.1239C124.79 54.3358 124.79 40.4147 124.79 26.6304C124.79 24.9968 123.466 23.6641 121.844 23.6641C119.12 23.6641 116.399 23.6641 113.675 23.668C113.349 23.668 113.081 23.9376 113.081 24.2659V46.1285C113.081 46.3943 112.914 46.617 112.666 46.6952C112.414 46.7734 112.154 46.6796 112.006 46.4607L97.4529 24.7154C97.0027 24.0432 96.308 23.6719 95.5047 23.6719H83.2954C82.9694 23.6719 82.7017 23.9415 82.7017 24.2698V68.1239C82.7017 68.4522 82.9694 68.7219 83.2954 68.7219H91.4763C92.2952 68.7219 92.986 68.4327 93.5643 67.8465C94.1425 67.2602 94.4258 66.5607 94.4219 65.736L94.2822 42.9238C94.2783 42.658 94.4452 42.4313 94.6975 42.3532C94.9497 42.275 95.2136 42.3688 95.3572 42.5877L112.111 67.6706C112.561 68.3428 113.256 68.7141 114.063 68.718L114.055 68.7219Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M140.205 68.1359C140.205 54.3086 140.205 40.4814 140.205 26.658C140.205 25.0165 138.881 23.676 137.259 23.676H129.094C128.768 23.676 128.5 23.9457 128.5 24.274V63.0279C128.434 65.7519 129.92 68.6987 132.928 68.7065L139.611 68.73C139.774 68.73 139.918 68.6713 140.034 68.5541C140.15 68.4368 140.209 68.2961 140.209 68.132L140.205 68.1359Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M217.908 68.7221H228.045C228.371 68.7221 228.638 68.4525 228.638 68.1242C228.638 54.336 228.638 40.4227 228.638 26.6346C228.638 25.0009 227.315 23.6682 225.693 23.6682C222.972 23.6682 220.248 23.6682 217.524 23.6721C217.198 23.6721 216.93 23.9418 216.93 24.2701V46.1326C216.93 46.3984 216.767 46.6212 216.515 46.6993C216.262 46.7775 216.002 46.6837 215.855 46.4648L201.301 24.7195C200.851 24.0473 200.157 23.676 199.353 23.676H187.144C186.818 23.676 186.55 23.9457 186.55 24.274V68.1281C186.55 68.4564 186.818 68.7261 187.144 68.7261H195.325C196.148 68.7261 196.835 68.4368 197.417 67.8506C197.995 67.2644 198.278 66.5648 198.271 65.7402L198.131 42.9279C198.131 42.6621 198.294 42.4355 198.546 42.3573C198.798 42.2791 199.062 42.3729 199.206 42.5918L215.96 67.6747C216.41 68.3509 217.104 68.7221 217.912 68.7221H217.908Z"
      fill="currentColor"
    />
    <path
      d="M182.087 29.8237C178.831 25.3175 171.931 23.1914 165.982 23.1914C151.409 23.2813 143.131 34.5643 143.046 46.4648C143.046 58.3615 151.153 69.4764 165.982 69.4764C172.47 69.4764 177.64 67.8193 182.456 61.9922C182.654 61.7538 182.638 61.4099 182.425 61.191L178.397 57.0288C177.17 55.7625 175.245 55.5866 173.813 56.6145C171.252 58.4513 168.454 59.19 165.811 59.0571C159.776 58.7093 154.514 53.7615 154.599 46.5547C154.688 38.0426 160.463 33.6146 166.672 33.7905C168.947 33.853 171.318 34.5252 173.476 35.8697C174.904 36.7607 176.724 36.5028 177.849 35.2522L182.048 30.5818C182.239 30.3708 182.254 30.0581 182.087 29.8276V29.8237Z"
      fill="currentColor"
    />
    <path
      d="M89.5553 8.19162H93.4129V10.2786C93.4129 11.3104 91.8722 12.1936 89.99 12.1936C87.0056 12.1936 84.84 10.0129 84.84 7.06215C84.84 4.22869 86.8736 2.06745 89.5359 2.06745C90.8282 2.06745 92.1012 2.68104 92.9588 3.71281L94.4607 2.08699C93.1684 0.74647 91.3793 0 89.501 0C85.6783 0 82.6978 3.10313 82.6978 7.14031C82.6978 11.197 85.7016 14.2611 89.6911 14.2611C92.0274 14.2611 94.158 13.2254 95.4698 11.4472V6.54627H89.5592V8.19162H89.5553ZM100.523 2.25895H103.107C104.97 2.25895 105.77 2.853 105.77 4.22869C105.77 5.62393 104.951 6.2766 103.107 6.2766H100.523V2.25895ZM107.916 14.0696L104.951 8.13691C106.833 7.64057 107.916 6.26096 107.916 4.21306C107.916 1.64927 106.204 0.195411 103.2 0.195411H98.4697V14.0696H100.523V8.34795H102.766L105.618 14.0696H107.92H107.916ZM109.872 8.38704C109.872 12.1741 111.828 14.2611 115.383 14.2611C118.937 14.2611 120.932 12.1546 120.932 8.38704V0.195411H118.879V8.44566C118.879 11.0094 117.719 12.2953 115.441 12.2953C113.12 12.2953 111.925 10.9743 111.925 8.44566V0.195411H109.872V8.38704ZM125.935 2.26286H128.764C130.627 2.26286 131.426 2.91162 131.426 4.46318C131.426 6.05383 130.607 6.76122 128.764 6.76122H125.935V2.26286ZM125.935 14.0735V8.82866H128.861C131.826 8.82866 133.576 7.22239 133.576 4.46318C133.576 1.74697 131.865 0.195411 128.861 0.195411H123.882V14.0696H125.935V14.0735ZM134.888 7.12468C134.888 11.0681 137.95 14.265 141.749 14.265C145.529 14.265 148.591 11.0681 148.591 7.12468C148.591 3.20083 145.529 0.00390822 141.749 0.00390822C137.946 0.00390822 134.888 3.20083 134.888 7.12468ZM137.034 7.10514C137.034 4.33031 139.126 2.07136 141.749 2.07136C144.353 2.07136 146.445 4.33031 146.445 7.10514C146.445 9.9386 144.353 12.1975 141.749 12.1975C139.126 12.1975 137.034 9.9386 137.034 7.10514Z"
      fill="currentColor"
    />
  </svg>
);
